import { nodeActionSchema, type NodeAction } from "../../../schemas/index.ts";

// TODO: might be better perf to just check type
export const isNodeAction = (action: unknown): action is NodeAction => nodeActionSchema.safeParse(action).success;
